export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			sidebar: {
				type: 'default',
				body_type: 'default'
			},
			sidebar_setting: 'default-sidebar',
			sidebar_backround: 'sidebar-pattern1'
		},
		color: {
			layout_version: 'light',
			color: 'color-4',
			primary_color: '#4c2fbf',
			secondary_color: '#2e9de4',
			mix_layout: 'default'
		},
		router_animation: 'fadeIn'
	}
}
